'use client';

import { useQuery } from '@tanstack/react-query';

import { useWixInstanceContext } from '@/components/Contexts/WixInstanceContext';
import { useApiClient } from '@/hooks/useApiClient';

import type { CommentsData } from '@/types/feedback';

export function useComments(params: {
  /** Server-sealed context; the route takes the metasites only from it. */
  sealedContext?: string;
  enabled?: boolean;
}) {
  const apiClient = useApiClient();
  const instance = useWixInstanceContext();
  const { sealedContext, enabled = true } = params;

  return useQuery<CommentsData>({
    queryKey: ['comments', sealedContext],
    queryFn: async () => {
      const qs = new URLSearchParams({ ctx: sealedContext ?? '' });

      return apiClient
        .get<CommentsData>(`api/comments?${qs}`)
        .then((r) => r.data);
    },
    enabled: enabled && Boolean(sealedContext) && instance !== null,
  });
}
